
import kotlinx.browser.document
import kotlinx.browser.window
import react.FC
import react.Props
import react.create
import react.dom.client.createRoot
import react.dom.html.ReactHTML.div

val HeaderComponent = FC<Props>{
    div {
        id = "header"
        +"AsPac Granite"
    }
}

fun main() {
    val container = document.createElement("div")
    document.body!!.appendChild(container)

    if (window.location.href.lowercase().contains("granitecolors.html")) {
        val graniteColor = GraniteColors.create()
        createRoot(container).render(graniteColor)
    } else {
       val welcome = Welcome.create()
    //    val welcome = Welcome.create{ name = "abc" }
       createRoot(container).render(welcome)
    }
}